import { IDatabase } from '../../database';
import { FlowyGlobal } from '../../flowy';
import { rootGizmoDataV2ToV3 } from '../../gizmos/utils';
import { IFilledFormV2, IRootGizmoData } from '../../types';

interface IParams {
  rootGizmoData: (IRootGizmoData | IFilledFormV2)[];
  publicRG?: boolean;
  context: {
    // apiUrl: string;
    // user?: IUserV2;
    database?: IDatabase;
    global?: FlowyGlobal;
  };
}

/**
 * Remove data from the local storage
 *
 * @param {IRootGizmoData[]} rootGizmoData data we're going to remove from the local storage
 */
async function removeRootGizmoData({
  rootGizmoData,
  context,
}: IParams): Promise<void> {
  const { database, global } = context;

  if (database) {
    const attachments: {
      attachmentId: string;
      extension: string;
    }[] = [];

    for (const r of rootGizmoData) {
      let rgd: any = r;

      if (rgd.answers) {
        // If it has answers field it means it's v2 data
        rgd = rootGizmoDataV2ToV3({ data: rgd });
      }

      // In these loop we're going to look for gizmo data that includes an attachmentId
      for (const fid in rgd.d) {
        const gD = rgd.d[fid];

        if (gD?.fd?.attachmentId) {
          // And we're going to add it to the attachments array in order to remove them later
          attachments.push({
            attachmentId: gD.fd.attachmentId,
            extension: gD.fd.extension || 'jpeg',
          });
        }
      }

      try {
        await database.delete({
          type: 'filledForms',
          fid: rgd.fid,
        });
      } catch (e) {}

      if (attachments.length > 0) {
        const platformInterface = global?.getPlatformInterface();
        if (platformInterface) {
          for (const attachment of attachments) {
            await platformInterface.fileRemove({
              path: '',
              fileFid: attachment.attachmentId,
              fileExtension: attachment.extension,
            });
          }
        }
      }
    }
  }
}

export default removeRootGizmoData;
